import * as React from "react";
const SvgFiRrRefer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-refer_svg__a)">
      <path
        fill="#062147"
        d="M5.5 7C7.43 7 9 5.43 9 3.5S7.43 0 5.5 0 2 1.57 2 3.5 3.57 7 5.5 7m0-5C6.327 2 7 2.673 7 3.5S6.327 5 5.5 5 4 4.327 4 3.5 4.673 2 5.5 2m12 15c2.481 0 4.5-2.019 4.5-4.5S19.981 8 17.5 8a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5m0-7c1.379 0 2.5 1.121 2.5 2.5S18.879 15 17.5 15a2.5 2.5 0 0 1-2.5-2.5c0-1.379 1.121-2.5 2.5-2.5m-9.067 8.607c.76.762.76 2.023-.013 2.798l-2.199 2.288a.997.997 0 0 1-1.414.028 1 1 0 0 1-.028-1.414L6.035 21H4c-2.206 0-4-1.794-4-4v-1a1 1 0 1 1 2 0v1c0 1.103.897 2 2 2h2.029l-1.25-1.307a1 1 0 0 1 1.442-1.387zm14.85 5.352a1 1 0 0 1-1.241-.677C21.474 21.349 19.606 20 17.501 20s-3.973 1.35-4.541 3.282a1 1 0 0 1-1.242.677 1 1 0 0 1-.677-1.241C11.858 19.941 14.514 18 17.5 18s5.643 1.94 6.459 4.718a1 1 0 0 1-.677 1.241zM10.352 12.937a1.005 1.005 0 0 1-1.288-.586C8.537 10.945 7.105 10 5.501 10s-3.037.944-3.563 2.351a1 1 0 1 1-1.873-.701c.818-2.183 3.003-3.649 5.437-3.649s4.618 1.467 5.437 3.649a1 1 0 0 1-.585 1.287z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-refer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRefer;
